import React, { useState } from "react";
import { Download, Share2, Loader2 } from "lucide-react";
import { toast } from "sonner";

/* One-tap save/share of the payment QR (no long-press needed). */
export const QrSaveButtons = ({ src, name = "royal-laxmi-payment-qr" }) => {
  const [busy, setBusy] = useState("");
  const blob = async () => { const r = await fetch(src, { credentials: "include" }); if (!r.ok) throw new Error("QR not available"); return await r.blob(); };
  const save = async () => {
    setBusy("save");
    try {
      const b = await blob();
      const url = URL.createObjectURL(b);
      const a = document.createElement("a"); a.href = url; a.download = `${name}.png`; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 4000);
      toast.success("QR saved to your phone (Downloads / Gallery). Open GPay / PhonePe → scan from gallery.");
    } catch (e) { toast.error(e.message || "Could not save QR"); } finally { setBusy(""); }
  };
  const share = async () => {
    setBusy("share");
    try {
      const b = await blob();
      const file = new File([b], `${name}.png`, { type: b.type || "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) await navigator.share({ files: [file], title: "ROYAL LAKSHMI payment QR" });
      else await save();
    } catch (e) { if (e.name !== "AbortError") toast.error("Could not share QR"); } finally { setBusy(""); }
  };
  return (
    <div className="flex gap-2 mt-2 w-full" data-testid="qr-save-buttons">
      <button onClick={save} disabled={!!busy} className="flex-1 py-2 rounded-xl text-xs font-black bg-slate-900 text-white flex items-center justify-center gap-1 disabled:opacity-60" data-testid="qr-download-btn">{busy === "save" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />}Download QR</button>
      <button onClick={share} disabled={!!busy} className="flex-1 py-2 rounded-xl text-xs font-black rl-card text-slate-800 flex items-center justify-center gap-1 disabled:opacity-60" data-testid="qr-share-btn">{busy === "share" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Share2 className="w-3.5 h-3.5" />}Open in UPI app</button>
    </div>
  );
};
